import { Paper, Popover, Typography } from "@mui/material";
import RCSettings from "./Settings";
import SettingView from "./SettingView";
import { glassColor } from "./Colors";

export default function SettingsWindow({
  settings,
  open,
  setOpen,
  anchorEl,
  updateSetting,
}: {
  settings: RCSettings;
  open: boolean;
  setOpen: (open: boolean) => void;
  anchorEl: HTMLElement | null;
  updateSetting: (
    name: string,
    type: string,
    value: any,
    index: number
  ) => void;
}) {
  return (
    <Popover
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          sx: {
            padding: 2,
            backgroundColor: glassColor(),
            color: "secondary.main",
            backdropFilter: "blur(10px)",
          },
        },
      }}
    >
      <div>
        <Typography color="secondary" fontWeight={"bold"} fontSize={settings.settings.length > 0 ? 24 : 14}>
          {settings.settings.length === 0 ? (
            <span>No Settings Received from Groove Catcher</span>
          ) : (
            <span>Settings</span>
          )}
        </Typography>
        {settings.settings.map((setting) => {
          return (
            <SettingView setting={setting} updateSetting={updateSetting} />
          );
        })}
      </div>
    </Popover>
  );
}
